module.exports = __webpack_public_path__ + "img/twitter.bfc55a7f.svg";